import { Hero } from "../components/landing/Hero";
import { DeveloperAccess } from "../components/landing/DeveloperAccess";
import { GetStarted } from "../components/landing/GetStarted";
import { FAQ } from "../components/landing/FAQ";

export const LandingPage = () => (
    <>
        <Hero className="mt-12 mb-16 px-6" />

        <DeveloperAccess className="py-16 px-6 bg-secondary" />

        <GetStarted className="py-16 px-6 bg-secondary" />

        <FAQ className="py-16 px-6" />
    </>
)